import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "./adminShared";
import { formatDate } from "@/lib/format";
import { Inbox, CalendarCheck, Users, MessageSquareQuote } from "lucide-react";

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <p className="text-earth/50">Loading…</p>;

  const stats = [
    { icon: Inbox, label: "New enquiries (7d)", value: d.newInquiries },
    { icon: CalendarCheck, label: "Upcoming bookings", value: d.upcomingBookings },
    { icon: MessageSquareQuote, label: "Pending testimonials", value: d.pendingTestimonials },
    { icon: Users, label: "Total bookings", value: d.totalBookings },
  ];

  return (
    <div>
      <h1 className="text-3xl text-earth mb-6" style={{ fontWeight: 600 }}>Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {stats.map((s) => (
          <Card key={s.label} className="p-5">
            <s.icon className="text-gold mb-3" size={22} />
            <div className="text-3xl text-earth font-display" style={{ fontWeight: 600 }}>{s.value}</div>
            <div className="text-xs text-earth/60 uppercase tracking-wider mt-1">{s.label}</div>
          </Card>
        ))}
      </div>
      <Card className="p-6">
        <h2 className="text-xl text-earth mb-4" style={{ fontWeight: 600 }}>Upcoming workshops</h2>
        {d.upcomingWorkshops.length === 0 ? <p className="text-earth/50">None scheduled.</p> : (
          <ul className="divide-y divide-hairline">
            {d.upcomingWorkshops.map((w, i) => (
              <li key={i} className="flex justify-between py-3">
                <div><p className="text-earth font-semibold">{w.title}</p><p className="text-sm text-earth/50">{formatDate(w.startDate)}</p></div>
                <span className="text-sm text-gold-dark font-semibold">{w.seatsRemaining} / {w.capacity} seats left</span>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
